import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const GetSpaceNameQuery: GraphQLTaggedNode = graphql`
	query GetSpaceNameQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			name
		}
	}
`;
